// The output registry (plan, "UI: modular"): which component draws each
// output type of a run. Phase 1 has flag, measurements and mask; a type with
// no entry here (objects, heatmap… until they arrive) draws nothing.

import type { ComponentType } from 'react';
import type { RunOutput } from '../types';
import { FlagOutputs } from './FlagOutput';
import { MaskOutputs } from './MaskOutput';
import { MeasurementsOutputs } from './MeasurementsOutput';
import type { OutputRendererProps } from './types';

export type { OutputEnv, OutputRendererProps } from './types';

export const outputRegistry: Record<string, ComponentType<OutputRendererProps>> = {
  flag: FlagOutputs,
  measurements: MeasurementsOutputs,
  mask: MaskOutputs,
};

/** The order a result reads in: the verdict, the numbers, then the masks. */
export const OUTPUT_ORDER = ['flag', 'measurements', 'mask'];

export interface OutputSection {
  type: string;
  outputs: RunOutput[];
  Renderer: ComponentType<OutputRendererProps>;
}

/** A run's outputs by type, in reading order; types nobody draws are left out. */
export function outputSections(outputs: RunOutput[] | null | undefined): OutputSection[] {
  const types: string[] = [];
  for (const o of outputs ?? []) if (!types.includes(o.type)) types.push(o.type);
  const rank = (t: string) => {
    const i = OUTPUT_ORDER.indexOf(t);
    return i >= 0 ? i : OUTPUT_ORDER.length;
  };
  return types
    .filter((t) => Object.prototype.hasOwnProperty.call(outputRegistry, t))
    .sort((a, b) => rank(a) - rank(b))
    .map((type) => ({ type, outputs: (outputs ?? []).filter((o) => o.type === type), Renderer: outputRegistry[type] }));
}
